/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    email_senders: [],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_EMAIL_SENDERS:

            return {
                ...state,
                email_senders: action.payload.data,
            }

        default: return state;

    }

}

export default reducer;
